import { messages } from './SettingsMessages';

export const ROUTES = {
  account: '/settings/account',
  billing: '/settings/billing',
  contact: '/settings/contact',
  membership: '/settings/membership',
  charges: '/settings/charges',
  settings: '/settings',
};

export const GENDERS = {
  female: 'Female',
  male: 'Male',
  nonBinary: 'Non-binary',
  selfIdentifying: 'Self-identifying',
  unspecified: 'Unspecified',
};

export const GENDER_OPTIONS = [
  {
    id: GENDERS.female,
    label: messages.female,
  },
  {
    id: GENDERS.male,
    label: messages.male,
  },
  {
    id: GENDERS.nonBinary,
    label: messages.nonBinary,
  },
  {
    id: GENDERS.selfIdentifying,
    label: messages.selfIdentifying,
  },
  {
    id: GENDERS.unspecified,
    label: messages.unspecified,
  },
];
